// Форматирование чисел, денег и дат в локали ru-RU.
// Деньги и числа приходят как number, время — epoch-ms.

const moneyFmt = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
})

const intFmt = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 })

const percentFmt = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 1
})

/**
 * Сумма с разделением разрядов БЕЗ подписи валюты, напр. «12 500».
 * Подпись валюты добавляется на стороне вызова: в JSX — `{money(x)} <Cur/>`,
 * в строках — `${money(x)} ${currencyText(display)}`. Так подпись уважает
 * клубную настройку отображения (знак / BYN / бел.руб).
 */
export function money(value: number): string {
  return moneyFmt.format(value)
}

/** Целое количество с разделением разрядов. */
export function count(value: number): string {
  return intFmt.format(value)
}

/** Доля в процентах от целого, напр. «42,5 %». */
export function share(part: number, total: number): string {
  if (!total) return '—'
  return `${percentFmt.format((part / total) * 100)} %`
}

/** Полная дата-время в локали клуба, напр. «10.06.2026, 14:32». */
export function dateTime(ms: number | null): string {
  if (ms == null) return '—'
  return new Date(ms).toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

/** Только дата, напр. «10.06.2026». */
export function dateOnly(ms: number): string {
  return new Date(ms).toLocaleDateString('ru-RU')
}

/** Длительность в минутах → «2 ч 15 мин». */
export function duration(min: number): string {
  if (min <= 0) return '0 мин'
  const h = Math.floor(min / 60)
  const m = Math.round(min % 60)
  if (h && m) return `${h} ч ${m} мин`
  if (h) return `${h} ч`
  return `${m} мин`
}

const PAYMENT_LABEL: Record<string, string> = {
  cash: 'Наличные',
  card: 'Карта',
  mixed: 'Смешанная'
}

/** Человекочитаемый способ оплаты. */
export function paymentLabel(method: string | null): string {
  if (!method) return '—'
  return PAYMENT_LABEL[method] ?? method
}

/** Преобразовать значение <input type="date"> (YYYY-MM-DD) в epoch-ms начала суток. */
export function dateInputToMs(value: string): number {
  const [y, m, d] = value.split('-').map(Number)
  return new Date(y, (m ?? 1) - 1, d ?? 1, 0, 0, 0, 0).getTime()
}

/** Преобразовать epoch-ms в строку YYYY-MM-DD для <input type="date">. */
export function msToDateInput(ms: number): string {
  const d = new Date(ms)
  const p = (n: number): string => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
}
